/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject} from '@angular/core';
import template from './invoice-translation-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../components/session/local-network-profile';

@Component({
  standalone: false,
  selector: 'adn-invoice-translation-list-page',
  template
})
export class InvoiceTranslationListPageComponent extends AdminResourceListPageBase {
  readonly itemStateName = 'app.rep.invoice-translations.invoice-translation';

  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'description'},
    {label: 'locale', param: '', sortable: false}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any
  ) {
    super(LocalNetworkProfile);
  }
}
